import { useRef, useEffect, memo } from 'react';
import { DateTooltip } from './DateTooltip';

const dataAttrForNights = 'data-rdr-minimum-night';

function DayDefault({
  value,
  tooltip,
  isMinimumDay,
  enabledTooltip,
  dataTestId,
  className,
}) {
  const ref = useRef(null);
  useEffect(() => {
    const parent = ref.current?.parentElement?.parentElement;
    if (parent && isMinimumDay) {
      parent.setAttribute('disabled', true);
      parent.setAttribute(dataAttrForNights, true);
    }
    return () => {
      if (parent && isMinimumDay) {
        parent.removeAttribute(dataAttrForNights);
        parent.removeAttribute('disabled');
      }
    };
  }, [isMinimumDay]);
  return (
    <DateTooltip
      ref={ref}
      text={tooltip}
      enabled={enabledTooltip}
      dataTestId={dataTestId}
      className={className}
    >
      {value}
    </DateTooltip>
  );
}

export const Day = memo(DayDefault);
